import { useMemo } from 'react'
import { DataTable } from '@/common/ui/table/data-table'
import { TableCell } from '@/common/ui/table'
import { ProviderSummary } from '../../types'
import { columns } from './constants'

interface TransactionSummaryTableProps {
	data: ProviderSummary[]
	isLoading?: boolean
}

export default function TransactionSummaryTable({
	data,
	isLoading,
}: TransactionSummaryTableProps) {
	// Calculate totals
	const totals = useMemo(() => {
		if (!data || data.length === 0) {
			return null
		}

		const total = data.reduce(
			(acc, item) => ({
				totalSuccessTransaction:
					acc.totalSuccessTransaction + item.totalSuccessTransaction,
				totalTurnOver: acc.totalTurnOver + item.totalTurnOver,
				totalTransferIn: acc.totalTransferIn + item.totalTransferIn,
				totalTransferOut: acc.totalTransferOut + item.totalTransferOut,
				totalBetAmount: acc.totalBetAmount + item.totalBetAmount,
				totalSettleAmount: acc.totalSettleAmount + item.totalSettleAmount,
			}),
			{
				totalSuccessTransaction: 0,
				totalTurnOver: 0,
				totalTransferIn: 0,
				totalTransferOut: 0,
				totalBetAmount: 0,
				totalSettleAmount: 0,
			},
		)

		const totalProfit = total.totalTransferIn - total.totalTransferOut

		return { ...total, totalProfit }
	}, [data])

	// Create footer row
	const footerRow = useMemo(() => {
		if (!totals) return null

		return (
			<>
				<TableCell className="font-bold">รวม</TableCell>
				<TableCell className="font-bold">
					{totals.totalSuccessTransaction.toLocaleString()}
				</TableCell>
				<TableCell className="font-bold">
					{totals.totalTurnOver.toLocaleString()}
				</TableCell>
				<TableCell className="font-bold text-green-600">
					{totals.totalTransferIn.toLocaleString()}
				</TableCell>
				<TableCell className="font-bold text-red-600">
					{totals.totalTransferOut.toLocaleString()}
				</TableCell>
				<TableCell
					className={`font-bold ${
						totals.totalProfit >= 0 ? 'text-green-600' : 'text-red-600'
					}`}
				>
					{totals.totalProfit.toLocaleString()}
				</TableCell>
				<TableCell className="font-bold">
					{totals.totalBetAmount.toLocaleString()}
				</TableCell>
				<TableCell className="font-bold">
					{totals.totalSettleAmount.toLocaleString()}
				</TableCell>
				<TableCell>{/* Actions column - empty */}</TableCell>
			</>
		)
	}, [totals])

	return (
		<DataTable
			columns={columns}
			data={data}
			isLoading={isLoading}
			footer={footerRow}
		/>
	)
}
